import { defineMessages } from 'react-intl'

export const PROFILE_DESIRED_OUTCOME = {
  FEEL_BETTER: 'FEEL_BETTER',
  HAVE_MORE_ENERGY: 'HAVE_MORE_ENERGY',
  GAIN_CONFIDENCE: 'GAIN_CONFIDENCE',
  MOVE_BETTER: 'MOVE_BETTER',
  EAT_HEALTHIER: 'EAT_HEALTHIER'
}

export const PROFILE_DESIRED_OUTCOMES = Object.values(PROFILE_DESIRED_OUTCOME)

const labels = defineMessages({
  feelBetter: {
    id: 'ProfileDesiredOutcome.feelBetter',
    defaultMessage: 'Feel better',
    description: 'The customer wants to feel better physically and mentally.'
  },
  haveMoreEnergy: {
    id: 'ProfileDesiredOutcome.haveMoreEnergy',
    defaultMessage: 'Have more energy',
    description: 'The customer wants to boost their daily energy levels.'
  },
  gainConfidence: {
    id: 'ProfileDesiredOutcome.gainConfidence',
    defaultMessage: 'Gain confidence',
    description: 'The customer wants to feel more confident in their body and abilities.'
  },
  moveBetter: {
    id: 'ProfileDesiredOutcome.moveBetter',
    defaultMessage: 'Move better',
    description: 'The customer wants to move more easily, efficiently, and without pain.'
  },
  eatHealthier: {
    id: 'ProfileDesiredOutcome.eatHealthier',
    defaultMessage: 'Eat healthier',
    description: 'The customer wants to improve their eating habits and nutrition.'
  }
})

export const PROFILE_DESIRED_OUTCOME_MESSAGE = {
  [PROFILE_DESIRED_OUTCOME.FEEL_BETTER]: labels.feelBetter,
  [PROFILE_DESIRED_OUTCOME.HAVE_MORE_ENERGY]: labels.haveMoreEnergy,
  [PROFILE_DESIRED_OUTCOME.GAIN_CONFIDENCE]: labels.gainConfidence,
  [PROFILE_DESIRED_OUTCOME.MOVE_BETTER]: labels.moveBetter,
  [PROFILE_DESIRED_OUTCOME.EAT_HEALTHIER]: labels.eatHealthier
}

export const PROFILE_DESIRED_OUTCOME_EMOJI = {
  [PROFILE_DESIRED_OUTCOME.FEEL_BETTER]: '😊',
  [PROFILE_DESIRED_OUTCOME.HAVE_MORE_ENERGY]: '⚡',
  [PROFILE_DESIRED_OUTCOME.GAIN_CONFIDENCE]: '😎',
  [PROFILE_DESIRED_OUTCOME.MOVE_BETTER]: '🏃',
  [PROFILE_DESIRED_OUTCOME.EAT_HEALTHIER]: '🥗'
}
